import React, { useEffect, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { CreateSession } from '../../FeatureRedux/CompanyReducer/loginCompany';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Logo from '../IMG/atom1.png'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [shake, setShake] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSuccess, setIsSuccess] = useState(false);

  const dispatch = useDispatch();
  const { data, error, isLoading } = useSelector((state) => state.CreateSession);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setShake(true);

      setTimeout(() => {
        setShake(false);
        setErrors({});
      }, 1000);
      return;
    }

    dispatch(CreateSession(formData));
    // console.log("Form submitted with:", formData);
  };

  useEffect(() => {
    if (error && !isLoading) {
      toast.error(error || "Something went wrong. Please try again.");
    }

    if (data && !error && !isLoading) {
      toast.success("Login successful! Redirecting...");
      localStorage.setItem('token', data.company);
      Cookies.set('xdjadken', data.isMaster);
      setIsSuccess(true);
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1500);
    }
  }, [data, error, isLoading]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap');

        body {
          margin: 0;
          padding: 0;
          font-family: 'Inter', sans-serif;
          background: linear-gradient(to right, #f8fafc, #ffffff);
          color: #111827;
        }

        .login-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
        }

        .login-box {
          background: rgba(255, 255, 255, 0.95);
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
          padding: 3rem 2.5rem;
          width: 100%;
          max-width: 420px;
          transition: all 0.2s ease;
          animation: fadeIn 0.5s ease-in-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .login-box.shake {
          animation: shake 0.4s;
        }

        @keyframes shake {
          0% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          50% { transform: translateX(5px); }
          75% { transform: translateX(-5px); }
          100% { transform: translateX(0); }
        }

        .login-logo {
          display: flex;
          justify-content: center;
          margin-bottom: 2rem;
        }

        .login-logo img {
          width: 80px;
          height: auto;
          transition: transform 0.3s ease;
        }

        .login-logo img:hover {
          transform: scale(1.05);
        }

        .login-title {
          font-size: 1.5rem;
          font-weight: 600;
          text-align: center;
          margin-bottom: 2rem;
          color: #111827;
        }

        .form-group {
          position: relative;
          margin-bottom: 2rem;
        }

        .input-label {
          font-size: 0.875rem;
          color: #6B7280;
          position: absolute;
          top: 1rem;
          left: 16px;
          transition: 0.3s ease all;
          pointer-events: none;
          background-color: #ffffff;
          padding: 0 4px;
        }

        .input-field {
          width: 100%;
          padding: 1rem;
          padding-top: 1.5rem;
          font-size: 1rem;
          border: 1px solid ${errors.email || errors.password ? '#EF4444' : '#d1d5db'};
          border-radius: 8px;
          background: #ffffff;
          transition: border-color 0.3s, box-shadow 0.3s;
        }

        .input-field:focus {
          border-color: #2563eb;
          outline: none;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
        }

        .input-field:focus + .input-label,
        .input-field:not(:placeholder-shown) + .input-label {
          top: -0.5rem;
          font-size: 0.75rem;
          color: #2563eb;
        }

        .error-message {
          color: #EF4444;
          font-size: 0.875rem;
          margin-top: 0.25rem;
        }

        .submit-btn {
          width: 100%;
          padding: 0.75rem;
          background-color: #2563eb;
          color: #fff;
          border: none;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 600;
          transition: all 0.2s ease;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .submit-btn:hover:not(:disabled) {
          background-color: #1d4ed8;
        }

        .submit-btn:disabled {
          opacity: 0.8;
          cursor: not-allowed;
        }

        .loader {
          width: 18px;
          height: 18px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top-color: #fff;
          animation: spin 1s ease-in-out infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .forgot-password {
          text-align: right;
          font-size: 0.875rem;
          color: #2563eb;
          margin-top: 0.5rem;
        }

        .password-toggle {
          position: absolute;
          right: 1rem;
          top: 2.25rem;
          cursor: pointer;
          color: #6b7280;
        }
      `}</style>

      <div className="login-container">
        <div className={`login-box ${shake ? 'shake' : ''}`}>
          {isSuccess ? (
            <div className="login-title">Login Successful!</div>
          ) : (
            <>
              <div className="login-logo">
                <img
                  src={Logo}
                  alt="Prodify Logo"
                />
              </div>

              <div className="login-title">Welcome Back</div>

              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder=" "
                    className="input-field"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <label className="input-label">Email Address</label>
                  {errors.email && <div className="error-message">{errors.email}</div>}
                </div>

                <div className="form-group relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    placeholder=" "
                    className="input-field"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <label className="input-label">Password</label>
                  <div
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </div>
                  {errors.password && <div className="error-message">{errors.password}</div>}
                </div>

                <div className="forgot-password">
                  <a href="#">Forgot password?</a>
                </div>

                <button
                  type="submit"
                  className="submit-btn mt-6"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="loader"></span>
                      Authenticating...
                    </>
                  ) : (
                    'Sign In'
                  )}
                </button>
              </form>
            </>
          )}
        </div>
        <ToastContainer 
          position="top-right" 
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </>
  );
}

// import { useEffect, useState } from 'react';
// import { Eye, EyeOff } from 'lucide-react';
// import { CreateSession } from '../../FeatureRedux/CompanyReducer/loginCompany';
// import { useDispatch, useSelector } from 'react-redux';
// import Cookies from 'js-cookie'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// export default function LoginPage() {
//     const [showPassword, setShowPassword] = useState(false);
//     const [formData, setFormData] = useState({ email: '', password: '' });

//     const dispatch = useDispatch();
//     const { data, error, isLoading } = useSelector((state) => state.CreateSession);

//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (!formData.email || !formData.password) {
//             alert("Please enter both email and password");
//             return;
//         }

//         dispatch(CreateSession(formData)); // Send email & password in a single object
//         console.log("Form submitted with:", formData);
//     };

//     useEffect(() => {
//         console.log(error ,"this is error ")
//         if (error && !isLoading) {
//             toast.error(error || "Something went wrong. Please try again.");
//         }
    
//         if (data && !error && !isLoading) {
//             localStorage.setItem('token', data.company);
//             Cookies.set('xdjadken', data.isMaster);
//             window.location.href = '/dashboard';
//         }
//     }, [data, error, isLoading]);
    

//     // useEffect(() => {
//     //     if (data && !error && !isLoading) {
//     //         localStorage.setItem('token', data.company);
//     //         console.log(data , "this is data")
//     //         const ans = Boolean(data.isMaster) && data.isMaster;
//     //         Cookies.set('xdjadken', data.isMaster);
//     //         window.location.href = '/dashboard';
//     //     }
//     // }, [data, error, isLoading]);

//     return (
//         <>
//             <style>{`
//                 @keyframes float {
//                     0% { transform: translateY(0px); }
//                     50% { transform: translateY(-10px); }
//                     100% { transform: translateY(0px); }
//                 }
//             `}</style>
//             <div className="h-screen flex items-center justify-center bg-gray-100">
//                 <div className="bg-white p-10 rounded-xl shadow-2xl w-full max-w-md">
//                     <div className="text-center mb-8">
//                         <img 
//                             src="http://13.202.13.248:3000/static/media/atom1.a701aa274e3a701996f2.png"
//                             alt="Prodify Logo"
//                             className="mx-auto w-32 h-auto mb-4"
//                             style={{ animation: "float 1.5s ease-in-out infinite" }}
//                         />
//                     </div>
//                     <form onSubmit={handleSubmit}>
//                         <div className="mb-5">
//                             <label className="block text-sm font-medium text-gray-700">Email</label>
//                             <input
//                                 type="email"
//                                 name="email"
//                                 placeholder="Enter your email"
//                                 className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 value={formData.email}
//                                 onChange={handleChange}
//                             />
//                         </div>
//                         <div className="mb-5 relative">
//                             <label className="block text-sm font-medium text-gray-700">Password</label>
//                             <input
//                                 type={showPassword ? 'text' : 'password'}
//                                 name="password"
//                                 placeholder="Enter your password"
//                                 className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
//                                 value={formData.password}
//                                 onChange={handleChange}
//                             />
//                             <div
//                                 className="absolute top-10 right-3 cursor-pointer"
//                                 onClick={() => setShowPassword(!showPassword)}
//                             >
//                                 {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                             </div>
//                         </div>
//                         <div className="flex items-center justify-end mb-6">
//                             <a href="#" className="text-blue-500 text-sm">Forgot password?</a>
//                         </div>
//                         <button 
//                             type="submit"
//                             className="w-full bg-blue-500 text-white py-3 rounded-md hover:bg-blue-600 transition"
//                             disabled={isLoading}
//                         >
//                             {isLoading ? "Logging in..." : "Login to your account"}
//                         </button>
//                     </form>
//                 </div>
//                 <ToastContainer position="top-right" autoClose={3000} />

//             </div>
//         </>
//     );
// }


// import React from 'react';

// const Login = () => {
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log("Form submitted");
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gray-900">
//       <div className="max-w-md w-full p-8 bg-white rounded-2xl shadow-lg">
//         <div className="flex justify-center mb-6">
//           <img 
//             src="http://13.202.13.248:3000/static/media/atom1.a701aa274e3a701996f2.png" 
//             alt="Logo" 
//             className="h-16"
//           />
//         </div>
//         <h2 className="text-3xl font-bold text-gray-900 text-center mb-6">Login</h2>
//         <form className="space-y-6" onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label htmlFor="username" className="block text-gray-600 mb-1">Username</label>
//             <input
//               type="text"
//               id="username"
//               className="w-full px-4 py-2 text-gray-900 bg-transparent border-2 border-gray-300 rounded-md focus:outline-none focus:ring-0 focus:border-green-400"
//               placeholder="Enter your username"
//               required
//             />
//           </div>

//           <div className="mb-4">
//             <label htmlFor="password" className="block text-gray-600 mb-1">Password</label>
//             <input
//               type="password"
//               id="password"
//               className="w-full px-4 py-2 text-gray-900 bg-transparent border-2 border-gray-300 rounded-md focus:outline-none focus:ring-0 focus:border-green-400"
//               placeholder="Enter your password"
//               required
//             />
//           </div>

//           <button
//             type="submit"
//             className="w-full py-3 bg-green-500 text-black font-bold rounded-md hover:bg-green-400 transition"
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Login;



